import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useRepoParams } from '../../../hooks/useRepoParams';
import { pullRequestApi } from '../../../api/client';
import './PullRequestListPage.css';

export function PullRequestListPage() {
    const { owner, repo } = useRepoParams();
    const repoPath = `${owner}/${repo}`;

    const [pulls, setPulls] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('open'); // open, merged, closed

    useEffect(() => {
        loadPulls();
    }, [repoPath, status]);

    const loadPulls = async () => {
        try {
            setLoading(true);
            const data = await pullRequestApi.list(repoPath, status);
            setPulls(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pr-list-page">
            <div className="page-header-row">
                <h1>Merge Requests</h1>
                <Link to={`/${repoPath}/-/pulls/new`} className="btn btn-primary">New Merge Request</Link>
            </div>

            <div className="filters">
                <button
                    className={`filter-btn ${status === 'open' ? 'active' : ''}`}
                    onClick={() => setStatus('open')}
                >
                    Open
                </button>
                <button
                    className={`filter-btn ${status === 'merged' ? 'active' : ''}`}
                    onClick={() => setStatus('merged')}
                >
                    Merged
                </button>
                <button
                    className={`filter-btn ${status === 'closed' ? 'active' : ''}`}
                    onClick={() => setStatus('closed')}
                >
                    Closed
                </button>
            </div>

            {loading ? (
                <div className="loading">Loading...</div>
            ) : (
                <div className="pr-list">
                    {pulls.length === 0 ? (
                        <div className="empty-state">No merge requests found.</div>
                    ) : (
                        pulls.map(pr => (
                            <div key={pr.id} className="pr-item">
                                <div className="pr-status-icon status-open">
                                    {/* Icon */}
                                    !
                                </div>
                                <div className="pr-content">
                                    <Link to={`/${repoPath}/-/pulls/${pr.id}`} className="pr-title">
                                        {pr.title}
                                    </Link>
                                    <div className="pr-meta">
                                        #{pr.id.substring(0, 6)} opened by {pr.author?.username} • {pr.sourceBranch} {'->'} {pr.targetBranch}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
}
